import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';;
import { Router } from '@angular/router';
import { ContractNatioNego } from '@core/models/contract-natio-nego.model';
import { BaseService } from '@core/services/base/base.service';
import { ErrorHandlerService, HttpError } from '@core/services/error-handler.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContractNatioNegoService extends BaseService {
  private natioNegotiationRoute = '/contract_natio_nego';

  constructor(
    private httpService: HttpClient,
    private snackBar: MatSnackBar,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) {
    super();
  }

  public getList(filter): Observable<any> {
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de récuperer la liste des négociations nationales. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    let url = environment.contract_microservice_api_base_url + '/contract_natio_nego?' + this.getParamsFromFilter(filter);

    return new Observable(observer => {
      this.httpService
        .get(url)
        .pipe(
          map(response => {
            let result = [];

            if (response['data']) {
              let natioNegotiationList: ContractNatioNego[] = [];

              response['data'].map(negotiation => {
                natioNegotiationList.push(new ContractNatioNego(negotiation));
              });

              return natioNegotiationList;
            }

            return result;
          })
        )
        .subscribe(
          (response: any) => observer.next(response),
          error => {
            this.errorHandlerService.showErrorMessage(httpErrors, error.status);
            observer.error(error);
          }
        );
    });
  }

  public create(negotiation: ContractNatioNego) {
    const url = environment.contract_microservice_api_base_url + this.natioNegotiationRoute;

    const data = { negotiation: negotiation };

    return new Observable(observer => {
      this.httpService.post(url, data).subscribe(
        response => {
          if (response && response['data']) {
            observer.next(new ContractNatioNego(response));
          } else {
            observer.next(response);
          }
        },
        error => observer.error(this.catchError(error))
      );
    });
  }

  public edit(negotiation: ContractNatioNego, id: string): Observable<any> {
    const url = environment.contract_microservice_api_base_url + this.natioNegotiationRoute + '/' + id;

    return new Observable(observer => {
      this.httpService.put(url, negotiation).subscribe(
        response => {
          if (response && response['data']) {
            observer.next(new ContractNatioNego(response));
          } else {
            observer.next(response);
          }
        },
        error => {
          this.catchError(error);
          observer.error(false);
        }
      );
    });
  }

  public remove(id) {
    let url = environment.contract_microservice_api_base_url + this.natioNegotiationRoute + '/' + id;

    return new Observable(observer => {
      this.httpService.delete(url).subscribe(
        () => {
          observer.next(true);
        },
        error => {
          this.catchError(error);
          observer.error(false);
        }
      );
    });
  }

  private catchError(error: any, routeRedirect: string = null): any {
    this.snackBar.open(error.error.data?.msg ? error.error.data.msg : 'Une erreur est survenue', null, {
      duration: 2000,
      verticalPosition: 'top',
    });

    if (routeRedirect) {
      this.router.navigate([routeRedirect]);
    }

    return error;
  }
}
